import { Container } from "react-bootstrap";

import { ColorsStyle } from "../../config/colors";

export default function LandingFooter(){

	return (
		<Container fluid style={{backgroundColor: ColorsStyle.Dark}}>
			<div className="m-4 text-center">
				Plataforma para Barbearias - <a href="https://tribobarber.com.br/privacy-policy">Politicas de Privacidades</a> - <a href="https://tribobarber.com.br/terms-of-use">Termo de uso</a> - Template por Tribo Barber - Copyright © Tribo Barber
			</div>
		</Container>
	)
}